import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Dropdown, Button } from 'semantic-ui-react';
import { PLATFORM_LABELS } from 'constants/billingPackage/platformConstants';

export const DEFAULT_FILTERS = {
  baseModule: 'all',
  approval: 'all',
  platform: 'all',
  duration: 'all',
};

const BASE_MODULE_OPTIONS = [
  { key: 'all', text: 'All Module', value: 'all' },
  { key: 'basic', text: 'Basic', value: 'Basic' },
  { key: 'pro', text: 'Pro', value: 'Pro' },
  { key: 'enterprise', text: 'Enterprise', value: 'Enterprise' },
];

const APPROVAL_OPTIONS = [
  { key: 'all', text: 'All', value: 'all' },
  { key: 'yes', text: 'Yes', value: 'yes' },
  { key: 'no', text: 'No', value: 'no' },
];

const PLATFORM_OPTIONS = [
  { key: 'all', text: 'All Platforms', value: 'all' },
  ...Object.entries(PLATFORM_LABELS).map(([key, text]) => ({
    key,
    text,
    value: key,
  })),
];

const filterFieldStyle = { minWidth: '180px' };
const filterLabelStyle = {
  display: 'block',
  marginBottom: '0.3em',
  fontWeight: 'bold',
};

const CustomPackageFilter = ({ packages, onApply, onReset }) => {
  const [pendingFilters, setPendingFilters] = useState(DEFAULT_FILTERS);

  const durationOptions = useMemo(() => {
    const quantities = [...new Set(packages.map(pkg => pkg.quantity))].sort(
      (a, b) => a - b
    );
    return [
      { key: 'all', text: 'All Durations', value: 'all' },
      ...quantities.map(quantity => ({
        key: quantity,
        text: `${quantity} month(s)`,
        value: quantity,
      })),
    ];
  }, [packages]);

  const handleFilterChange = field => (event, { value }) => {
    setPendingFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApply = () => onApply(pendingFilters);

  const handleReset = () => {
    setPendingFilters(DEFAULT_FILTERS);
    onReset();
  };

  return (
    <div
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        padding: '1em',
        backgroundColor: '#fafafa',
        marginBottom: '1.5em',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1em',
          fontWeight: 'bold',
        }}
      >
        <Icon name="filter" />
        Filter Customize Package
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: '1em',
          flexWrap: 'wrap',
        }}
      >
        <div style={filterFieldStyle}>
          <label style={filterLabelStyle}>Base Module</label>
          <Dropdown
            fluid
            selection
            options={BASE_MODULE_OPTIONS}
            value={pendingFilters.baseModule}
            onChange={handleFilterChange('baseModule')}
          />
        </div>
        <div style={filterFieldStyle}>
          <label style={filterLabelStyle}>Approval</label>
          <Dropdown
            fluid
            selection
            options={APPROVAL_OPTIONS}
            value={pendingFilters.approval}
            onChange={handleFilterChange('approval')}
          />
        </div>
        <div style={filterFieldStyle}>
          <label style={filterLabelStyle}>Platform</label>
          <Dropdown
            fluid
            selection
            options={PLATFORM_OPTIONS}
            value={pendingFilters.platform}
            onChange={handleFilterChange('platform')}
          />
        </div>
        <div style={filterFieldStyle}>
          <label style={filterLabelStyle}>Duration</label>
          <Dropdown
            fluid
            selection
            options={durationOptions}
            value={pendingFilters.duration}
            onChange={handleFilterChange('duration')}
          />
        </div>
        <div style={{ display: 'flex', gap: '0.5em', marginLeft: 'auto' }}>
          <Button basic onClick={handleReset}>
            Reset
          </Button>
          <Button primary onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

CustomPackageFilter.propTypes = {
  packages: PropTypes.array,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

CustomPackageFilter.defaultProps = {
  packages: [],
};

export default CustomPackageFilter;
